import { getSession } from "next-auth/react";

import * as Sentry from "@sentry/nextjs";

class ErrorLogger {
  constructor() {
    this.user = getSession();
  }

  logApiError(error) {
    return error;
  }

  sentryErrorLog() {
    let requestData = error.request.__sentry_xhr_v2__;

    Sentry.captureException(error, (scope) => {
      scope.setTransactionName(`${error.response.data.message}`);
      scope.setTag("API-ERROR", "API-ERROR");

      scope.setExtras({
        user: {
          name: this.user?.user?.name,
          email: this.user?.user?.email,
          phone: this.user?.user?.phone,
        },

        request: {
          url: error.request.responseURL,
          method: requestData?.method,
          body: JSON.stringify(requestData?.body),
        },

        response: JSON.stringify(error.response.data),
      });
      return scope;
    });
  }
}

export const errorLogger = new ErrorLogger();
